import React from "react";
import Input from './Form/Input'
import Next from './Next'


export default class UserForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        ...this.props.values
      }
    };
  }

  componentDidMount() {
    setTimeout(() => {
      let top = document.getElementById("addons").getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: top - 60,
        left: 0,
        behavior: 'smooth'
      });
    }, 100);
  }

  onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.callback({field: 'addOnsReady', value : true});
  }

  updateStateData = (data) => {
    const n = { [data.field]: data.value };
    this.setState({data : {...this.state.data, ...n}});
  }

  cb = (params) => {
    const n = { [params.field]: params.value };
    this.setState({data : {...this.state.data, ...n}});
    this.props.callback(params);
  }


  render() {
    console.log(this.state.data.addOns)
    return (
      <>
        <form onSubmit={this.onSubmit}>
          <Input
            label="Are you interested in any of the following additional services?"
            name='addOns'
            type='buttons'
            multiple={true}
            options={[
              'Integration at launch site',
              'Insurance',
              'Mission analysis and design',
              'Licensing',
              'Shipping terrestrial transportation',
              'Mission control operations',
              'Cloud computing',
              'Radio frequency registration',
              'Qualification test activities'
            ]}
            value={this.state.data.addOns}
            mainCntClass="row"
            btnCntClass="col-md-6"
            buttonsClass="w-100 mb-3 b-icon"
            callback={this.cb}
          />

            {(this.state.data.addOns.length > 0)?
              (<Next callback={this.onSubmit} text="Next" />)
              :
              (<Next callback={this.onSubmit} text="Proceed without extra services"/>)
            }
        </form>
      </>
    );
  }
}
